export const SET_LEVEL_MODAL = 'SET_LEVEL_MODAL';

export const setLevelModal = (state) => (dispatch) => {
    dispatch({ type: SET_LEVEL_MODAL, state });
};

export default {
    SET_LEVEL_MODAL,
    setLevelModal,
};
